import request from '@/api/request.js'

/**
 * 跨系统免登换票
 *
 * 由焱火后台管理系统（sport.yanhuotiyu.com）签发票据，
 * OA 落地页（/ssoLogin）携带 phone / ts / nonce / sign 调用本接口换取 OA 登录态。
 *
 * @param {Object} param { phone, ts, nonce, sign, from }
 */
export function ssoLogin(param) {
  return request({
    url: 'sys/auth/ssoLogin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: param
  })
}

/**
 * 反向免登 —— 签发「返回焱火后台管理系统」的带票地址（OA → 后台）
 *
 * 与 ssoLogin 对称：那边是后台签发、OA 换票；这里是 OA 签发、后台换票。
 * 本接口**需要 OA 登录态**（不在服务端白名单内），由 Header 的
 * 「返回焱火后台」调用，拿到地址后新窗口打开即可免密进入后台。
 *
 * 返回内容为字符串 URL（同样 120 秒有效、nonce 一次性）。
 */
export function mainSsoUrl() {
  return request({
    url: 'sys/auth/mainUrl',
    method: 'GET'
  })
}
